import { isEmpty } from 'lodash';
import type { AggregationOption } from '../types';

/**
 * Get price range from filter aggregation options
 *
 * @param priceAggregationOptions - Array of price filter options
 * @returns Tuple of [minPrice, maxPrice]
 */
export const getPriceRange = (priceAggregationOptions: AggregationOption[]): [number, number] => {
    let newMinPriceValue = 0;
    let newMaxPriceValue = 0;

    if (!isEmpty(priceAggregationOptions)) {
        const isJustOnePriceValueRange = priceAggregationOptions.length === 1;

        if (isJustOnePriceValueRange) {
            const onlyOnePriceValue = Number(priceAggregationOptions[0].value);
            // If only one price value is returned and it's greater than 0, use it as max
            if (onlyOnePriceValue > 0) {
                newMaxPriceValue = onlyOnePriceValue;
            }
        } else {
            newMinPriceValue = Number(priceAggregationOptions[0]?.value);
            newMaxPriceValue = Number(priceAggregationOptions[priceAggregationOptions.length - 1]?.value);
        }
    }

    return [newMinPriceValue, newMaxPriceValue];
};

/**
 * Format number with thousands separator
 *
 * @param value - Number to format
 * @returns Formatted string
 */
export const formatNumber = (value: number): string => {
    return new Intl.NumberFormat('vi-VN').format(value);
};

/**
 * Simple price formatter for display (without currency symbol)
 *
 * @param price - Price value
 * @returns Formatted price string with VND suffix
 */
export const formatPriceSimple = (price: number): string => {
    return `${formatNumber(price)}đ`;
};
